import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderby',
  pure: true

})
export class OrderbyPipe implements PipeTransform {

  transform(array: any): any {

  

    if(!array || array === undefined || array.length === 0) return [];
  
      array.sort((a: any, b: any) => {
        if(a.section_details){
          if (parseInt(a.section_details.order) < parseInt(b.section_details.order)) {
            return -1;
          } else if (parseInt(a.section_details.order) > parseInt(b.section_details.order)) {
            return 1;
          } else {
            return 0;
          }
        }else{
          if (parseInt(a.order) < parseInt(b.order)) {
            return -1;
          } else if (parseInt(a.order) > parseInt(b.order)) {
            return 1;
          } else {
            return 0;
          }
        }
              
     
      });
      return array;
    }

}
